import { Box, Stack, Typography } from "@mui/material";
import React from "react";

const dayOptions = [
  { label: "S", value: 0 },
  { label: "M", value: 1 },
  { label: "T", value: 2 },
  { label: "W", value: 3 },
  { label: "T", value: 4 },
  { label: "F", value: 5 },
  { label: "S", value: 6 },
];

interface IProps {
  selectedDays: number[];
  size: number;
}

export const DayDisplay = (props: IProps) => {
  const { selectedDays, size } = props;
  return (
    <Stack direction="row">
      {dayOptions.map((day) => (
        <Box
          sx={{
            borderRadius: "50%",
            width: size,
            height: size,
            backgroundColor: selectedDays.includes(day.value)
              ? "#1B72E8"
              : "#F3F3F3",
            color: selectedDays.includes(day.value) ? "white" : "#797F82",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginRight: "2px",
          }}
        >
          <Typography fontSize="0.6rem" fontWeight="bold">
            {day.label}
          </Typography>
        </Box>
      ))}
    </Stack>
  );
};
